import { Block } from "baseui/block";
import { FixedFooter } from "kanopi-components/Sticky/FixedFooter";
import React from "react";
import { NextButton } from "../NextButton/NextButton";

type TResponsiveNextButtonProps = {
  fixed: boolean;
  narrow: boolean;
  onClick: TOnMouseEventFunc;
  disabled: boolean;
  isLoading: boolean;
  text: string;
};

export const ResponsiveNextButton: React.FC<TResponsiveNextButtonProps> = ({
  fixed,
  narrow,
  onClick,
  disabled,
  isLoading,
  text,
}) => {
  // The className below is to assist with E2E testing.
  const className =
    !isLoading && !disabled ? "nextButton ready" : "nextButton notReady";
  const button = (
    <Block padding={narrow ? "scale800" : ["scale800", "scale800", "scale1600"]}>
      <NextButton
        data-testid={className}
        onClick={onClick}
        disabled={disabled}
        isLoading={isLoading}
      >
        {text}
      </NextButton>
    </Block>
  );
  if (fixed) {
    return <FixedFooter>{button}</FixedFooter>;
  }
  return button;
};
